import axios from 'axios';
import { toast } from 'react-toastify';
import { loadingAction } from '../redux/actions/loadingAction';
import baseURL from '../Config';

export const handleDeleteRequest = (url, isShowLoad = false, isShowToast = true, data) => async (dispatch) => {
    try {
        const loginData = JSON.parse(localStorage.getItem('adminUser') || localStorage.getItem('userDetails') || '{}');
        const accessToken = loginData?.data?.token || loginData?.data?.accessToken;
        if (isShowLoad) dispatch(loadingAction(true));
        const response = await axios({
            method: 'delete',
            url: `${baseURL + url}`,
            data,
            headers: {
                'Content-Type': 'application/json',
                authorization: `Bearer ${accessToken}`
            }
        });
        if (isShowToast) toast.success(response?.data?.message || 'Deleted successfully', { autoClose: 1000 });
        if (isShowLoad) dispatch(loadingAction(false));
        return response;
    } catch (error) {
        if (isShowLoad) dispatch(loadingAction(false));
        if (axios.isCancel(error)) return;
        if (error?.response?.status === 400 || error?.response?.status === 500) {
            toast.warn(error?.response?.data?.messages || error?.response?.data?.message || 'Something went wrong !!');
        } else {
            toast.warn(error?.response?.data?.messages || error?.response?.data?.message || 'Something went wrong !!');
        }

        return error?.response;
    }
};
